/// <reference path="ColorableSvgItem.js" />
/// <reference path="ColorSelector.js" />
/// <reference path="GenericSounds.js" />
/// <reference path="ListenerManager.js" />

var ChangeInProgress = false;
var ChangeElementFade = null;
var ChangeElementAppear = null;

class ChangeableMiniMeItem {
	constructor(editor, groupIdentifier, colorSelector, svgItems, customItems, setting, designedItemIdPrefix) {
		this.listenerManager = new ListenerManager();
		this.index = 0;
		this.namespace = "http://www.w3.org/2000/svg";
		this.givenItems = 0;
		this.store = null;
		this.itemInstancePrefix = designedItemIdPrefix;
		this.editor = editor;
		this.groupIdentifier = groupIdentifier;
		this.colorSelector = colorSelector;
		this.svgItems = svgItems;
		this.customItem = customItems;
		this.items = [];
		this.itemsLoaded = [];
		this.colorSelector = colorSelector;
		this.groupElement = document.createElementNS(this.namespace, "g");
		this.groupElement.setAttribute("class", this.groupIdentifier);
		this.editor.appendChild(this.groupElement);
		this.playFeedbackSound = colorSelector.playFeedbackSound;
		this.setting = setting;

		if (GenericSoundsInstance == null) {
			GenericSoundsInstance = new GenericSounds(this.playFeedbackSound);
		}

		this.givenItems = this.svgItems.length;

		// svg items are first in items array
		for (var i = 0; i < this.svgItems.length; ++i) {
			this.items.push({
				type: 'svg',
				content: this.svgItems[i]
			});
			this.itemsLoaded.push(null);
		}

		if (!(customItems.length == 1 && customItems[0] == "")) {
			for (var i = 0; i < customItems.length; i++) {
				// custom items come after svg items
				this.items.push({
					type: 'image',
					content: customItems[i]
				});
				this.itemsLoaded.push(null);
			}
		}

		if (typeof(this.setting) == "string" && this.setting.indexOf(this.itemInstancePrefix) == 0) {
			this.index = 0;
			for (var i = 0; i < this.items.length; i++) {
				if (this.items[i].type == 'image' && (this.itemInstancePrefix + this.items[i].content.id) == this.setting) {
					this.index = i;
					break;
				}
			}
		} else if (this.setting == null || parseInt(this.setting) > this.items.length) {
			this.index = 0;
		} else {
			this.index = this.setting - 1;
		}

		// load selected items
		var selectedItem = this.items[this.index];

		this.loadItem(selectedItem, this.index, true);

		// Add listener for events fired from the MiniMeCloset Vue component
		this.listenerManager.safeObserve(document, MINI_ME_CLOSET_EVENTS.SELECTED_ITEM_CHANGED, (event) => {
			this.itemSelectionEventHandler(event);
		});
	}

	addItem(item, visible) {
		this.groupElement.appendChild(item);

		item.style.display = visible ? "block" : "none";
	}

	loadItem(item, idx, visible) {
		if (item.type == "image") {
			// images need to be loaded first
			var customItem = this.createImageItem(item.content, idx);

			this.addItem(customItem, visible);
		} else if (item.type == "svg") {
			// svgs can be added directly
			var svg = document.createElementNS(this.namespace, "g");
			var chains = item.content.objectChains;
			for (var i = 0; i < chains.length; ++i) {
				var svgItem = this.createSvgItem(item.content, chains[i][0], chains[i][chains[i].length - 1]);
				svg.appendChild(svgItem);
			}
			this.addItem(svg, visible);

			this.itemsLoaded[idx] = svg;
		} else {
			throw ("Unknown item type " + item.type);
		}
	}

	createImageItem(imageItem, idx) {
		var image = document.createElementNS(this.namespace, "image");
		image.setAttribute("x", imageItem.x);
		image.setAttribute("y", imageItem.y);
		image.setAttribute("width", imageItem.width);
		image.setAttribute("height", imageItem.height);
		image.setAttribute("preserveAspectRatio", "none");
		image.id = this.itemInstancePrefix + imageItem.id;
		image.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', imageItem.src);
		image.style.pointerEvents = "painted";

		this.itemsLoaded[idx] = image;
		return image;
	}

	createSvgItem(svgItem, settingKey, colorableId) {
		var useSvg = document.createElementNS(this.namespace, 'use');
		useSvg.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + colorableId);

		var colorableItem = new ColorableSvgItem(this.colorSelector, useSvg, settingKey, colorableId);
		return colorableItem.item;
	}

	/**
		* @returns {string} The ID of the selected item (if it's loaded) otherwise an empty string.
	*/
	getSelectedItemId() {
		const selectedItem = this.items[this.index];
		return selectedItem ? selectedItem.content.id : '';
	}

	/**
		* Handles the event of an item selection fired by the
		* [MiniMeCloset.vue](../../typescript/Control/Vue/MiniMeCloset/MiniMeCloset.vue) component.
		* 
		* This checks if the selected item category belongs to the current instance,
		* if so, the selected item is applied.
		* 
		* @param {CustomEvent} event - The event object containing the selected item and category.
		* @returns {boolean} True if the item selection event was handled, false otherwise.
	*/
	itemSelectionEventHandler({ detail: { item, category } }) {
		if (category !== this.groupIdentifier) {
			return false;
		}

		var targetIndex = this.findOrAddItem(item);

		this.applyMiniMeItemByIndex(targetIndex);
		return true;
	}

	/**
		* Find an item in the items array or add it if not found.
		* @param {Object} itemData - Item data in internal format
		* @returns {number} The index of the item
	*/
	findOrAddItem(itemData) {
		var index = this.items.findIndex(item => item.content.id === itemData.content.id);

		if (index === -1) {
			index = this.items.length;
			this.items.push(itemData);
			this.itemsLoaded.push(null);
		}

		return index;
	}

	/**
		* Apply a selected item to the MiniMe using its index in the @see items array.
		* @param {number} selectedItemIndex - The index of the item to apply
	*/
	applyMiniMeItemByIndex(selectedItemIndex) {
		if (ColorSelectorActiveColor != null) {
			GenericSoundsInstance.softClickSound();
			this.colorSelector.resetColors();
		}

		GenericSoundsInstance.softClickSound();
		var currentIdx = this.index;
		var nextIdx = selectedItemIndex;

		if (this.itemsLoaded[nextIdx] == null) {
			this.loadItem(this.items[nextIdx], nextIdx, false);
		}

		this.itemsLoaded[currentIdx].style.pointerEvents = "none";
		this.fadeOutToNextItem(currentIdx, nextIdx);
		this.itemsLoaded[nextIdx].style.pointerEvents = "all";

		this.store = nextIdx + 1;  // store is 1-based index
		if (this.store > this.givenItems) {
			this.store = this.itemsLoaded[nextIdx].id;
		}
		this.index = nextIdx;
	}

	fadeOutToNextItem(currentIndex, nextIndex) {
		function fadeOver() {
			if (step < 10) {
				step++;
				ChangeElementFade.style.opacity -= 0.1;
				//weird workaround for broken JS += operator
				ChangeElementAppear.style.opacity = parseFloat(ChangeElementAppear.style.opacity) + 0.1;
				window.setTimeout(function() { fadeOver(); }, 50);
			} else {
				ChangeElementFade.style.opacity = 0;
				ChangeElementAppear.style.opacity = 1;
				ChangeElementAppear.style.cursor = "default";
				ChangeElementFade.style.cursor = "default";
				ChangeInProgress = false;
				MiniMeLastVersion++;
			}
		}
		ChangeInProgress = true;
		var ChangeElementFade = this.itemsLoaded[currentIndex];
		ChangeElementFade.style.opacity = 1;
		ChangeElementFade.style.cursor = "wait";
		var ChangeElementAppear = this.itemsLoaded[nextIndex];
		ChangeElementAppear.style.opacity = 0;
		ChangeElementAppear.style.cursor = "wait";
		ChangeElementAppear.style.display = "block";
		var step = 0;
		fadeOver();
	}
}

class MiniMeFaces extends ChangeableMiniMeItem {
	constructor(svgDoc, colorSelector, groupIdentifier, designedItemIdPrefix) {
		super(svgDoc, groupIdentifier, colorSelector, MiniMeStaticItems.face, [], MiniMeSettings.face, designedItemIdPrefix);
	}

	itemSelectionEventHandler(event) {
		if (super.itemSelectionEventHandler(event)) {
			MiniMeSettings.face = this.index + 1;  // MiniMeSettings is 1-based index
		}
	}
}

class MiniMeHair extends ChangeableMiniMeItem {
	constructor(svgDoc, colorSelector, groupIdentifier, designedItemIdPrefix) {
		super(svgDoc, groupIdentifier, colorSelector, MiniMeStaticItems.hair, [], MiniMeSettings.hair, designedItemIdPrefix);
	}

	itemSelectionEventHandler(event) {
		if (super.itemSelectionEventHandler(event)) {
			MiniMeSettings.hair = this.index + 1;  // MiniMeSettings is 1-based index
		}
	}
}

class MiniMeBottom extends ChangeableMiniMeItem {
	constructor(svgDoc, colorSelector, customItems, groupIdentifier, designedItemIdPrefix) {
		super(svgDoc, groupIdentifier, colorSelector, MiniMeStaticItems.bottom, customItems, MiniMeSettings.bottom, designedItemIdPrefix);
	}

	itemSelectionEventHandler(event) {
		if (super.itemSelectionEventHandler(event) && this.store) {
			MiniMeSettings.bottom = this.store;
		}
	}
}

class MiniMeTop extends ChangeableMiniMeItem {
	constructor(svgDoc, colorSelector, customItems, groupIdentifier, designedItemIdPrefix) {
		super(svgDoc, groupIdentifier, colorSelector, MiniMeStaticItems.top, customItems, MiniMeSettings.top, designedItemIdPrefix);
	}

	itemSelectionEventHandler(event) {
		if (super.itemSelectionEventHandler(event) && this.store) {
			MiniMeSettings.top = this.store;
		}
	}
}

class MiniMeShoes extends ChangeableMiniMeItem {
	constructor(svgDoc, colorSelector, customItems, groupIdentifier, designedItemIdPrefix) {
		super(svgDoc, groupIdentifier, colorSelector, MiniMeStaticItems.shoes, customItems, MiniMeSettings.shoes, designedItemIdPrefix);
	}

	itemSelectionEventHandler(event) {
		if (super.itemSelectionEventHandler(event) && this.store) {
			MiniMeSettings.shoes = this.store;
		}
	}
}
